import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// #1 Rounded rocks — a cluster of smooth worn pebbles, no two alike (plan 28
// stage 4: the rounded art style; rocks are soft toon stones, not faceted blobs).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/rock.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ ball, seed }) => {
    const base = shade(0x8a8a8a, (rand(seed) - 0.5) * 0.25);
    const count = 2 + Math.floor(rand(seed + 1) * 3);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 7) * Math.PI * 2;
      const size = 0.55 + rand(seed + i * 7 + 2) * 0.85;
      // Lumps sit close together (within ~half a radius) so they read as one
      // rock instead of scattered pebbles; first lump is centered & largest.
      const r = i === 0 ? 0 : size * (0.3 + rand(seed + i * 7 + 1) * 0.4);
      const cx = Math.cos(a) * r, cz = Math.sin(a) * r;
      const cy = size * 0.42;
      const col = shade(base, (rand(seed + i) - 0.5) * 0.2);
      // A squashed sphere (rot π/2 + depth<1 flattens the WORLD vertical) reads
      // as a worn pebble; radius ~0.9× the old blob circumradius keeps the mass
      // envelope. Extra variation salts live off a private base so the layout
      // salts (angle/size/offset above) stay byte-identical to the old build.
      const s2 = seed + 900 + i * 5;
      const R = size * 0.96;
      const depth = 0.78 + rand(s2) * 0.1;                  // 0.78..0.88 vertical squash
      ball(cx, cy, cz, R, col, depth, [Math.PI / 2, 0, 0]);
      // Fuse one smaller offset lobe into it so pebbles aren't perfect spheres.
      const ba = rand(s2 + 1) * Math.PI * 2;
      const bo = R * (0.32 + rand(s2 + 2) * 0.28);          // offset, stays within the main
      const br = R * (0.52 + rand(s2 + 3) * 0.24);          // smaller lobe
      ball(cx + Math.cos(ba) * bo, cy + (rand(s2 + 4) - 0.4) * R * 0.25, cz + Math.sin(ba) * bo, br, col, depth, [Math.PI / 2, 0, 0]);
    }
  };

export default build;
